import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["belowTopResult", "items", "positionOffset"];
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React from 'react';
export const TopResultSplitList = _ref => {
  let belowTopResult = _ref.belowTopResult,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$positionOffset = _ref.positionOffset,
    positionOffset = _ref$positionOffset === void 0 ? 0 : _ref$positionOffset,
    listProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const SearchRecommendationList = DomainSearchSuiteModule.SDK.Components.SearchRecommendationList;
  if (!belowTopResult || items.length === 0) {
    return /*#__PURE__*/React.createElement(SearchRecommendationList, _extends({}, listProps, {
      items: items,
      positionOffset: positionOffset
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchRecommendationList, _extends({}, listProps, {
    items: items.slice(0, 1),
    positionOffset: positionOffset
  })), belowTopResult, /*#__PURE__*/React.createElement(SearchRecommendationList, _extends({}, listProps, {
    items: items.slice(1),
    positionOffset: positionOffset + 1,
    firstSuggestionPrimary: false
  })));
};
//# sourceMappingURL=TopResultSplitList.js.map